import { useState, useEffect, useRef } from "react";

const testimonials = [
  {
    name: "김민준",
    role: "쇼핑몰 운영자",
    company: "스타일픽 대표",
    avatar: "https://readdy.ai/api/search-image?query=professional%20korean%20male%20entrepreneur%20in%20his%2030s%2C%20clean%20white%20background%2C%20confident%20smile%2C%20business%20casual%20attire%2C%20high%20quality%20portrait%20photography%2C%20soft%20studio%20lighting%2C%20sharp%20focus&width=80&height=80&seq=t1&orientation=squarish",
    rating: 5,
    text: "하루에 수천 건씩 주문 확인 문자를 보내는데, Signal SMS로 바꾼 뒤 발송 실패가 거의 없어졌어요. 속도도 빠르고 가격도 합리적이라 정말 만족합니다.",
    tag: "대량 발송",
  },
  {
    name: "이수연",
    role: "마케팅 팀장",
    company: "뷰티플러스 마케팅",
    avatar: "https://readdy.ai/api/search-image?query=professional%20korean%20female%20marketing%20manager%20in%20her%20late%2020s%2C%20clean%20white%20background%2C%20warm%20smile%2C%20business%20attire%2C%20high%20quality%20portrait%20photography%2C%20soft%20studio%20lighting&width=80&height=80&seq=t2&orientation=squarish",
    rating: 5,
    text: "프로모션 문자 예약 발송 기능이 정말 편해요. 캠페인 일정에 맞춰 미리 세팅해두면 알아서 발송되니까 업무 효율이 훨씬 올라갔습니다.",
    tag: "예약 발송",
  },
  {
    name: "박성호",
    role: "개발팀 리드",
    company: "핀테크스타트업 CTO",
    avatar: "https://readdy.ai/api/search-image?query=professional%20korean%20male%20software%20developer%20in%20his%20early%2030s%2C%20clean%20white%20background%2C%20casual%20smart%20attire%2C%20confident%20expression%2C%20high%20quality%20portrait%20photography%2C%20natural%20lighting&width=80&height=80&seq=t3&orientation=squarish",
    rating: 5,
    text: "API 문서가 깔끔하게 정리되어 있어서 연동이 정말 쉬웠어요. 인증번호 발송 시스템을 하루 만에 붙였습니다. 개발자 친화적인 서비스예요.",
    tag: "API 연동",
  },
  {
    name: "최지영",
    role: "병원 원무과장",
    company: "서울 연세의원",
    avatar: "https://readdy.ai/api/search-image?query=professional%20korean%20female%20hospital%20administrator%20in%20her%2040s%2C%20clean%20white%20background%2C%20professional%20smile%2C%20formal%20attire%2C%20high%20quality%20portrait%20photography%2C%20soft%20lighting&width=80&height=80&seq=t4&orientation=squarish",
    rating: 5,
    text: "예약 알림 문자를 자동으로 보내고 있는데, 환자분들 반응이 정말 좋아요. 노쇼율이 눈에 띄게 줄었고, 관리도 편해졌습니다.",
    tag: "예약 알림",
  },
  {
    name: "정우진",
    role: "프랜차이즈 본부장",
    company: "카페브루 운영본부",
    avatar: "https://readdy.ai/api/search-image?query=professional%20korean%20male%20franchise%20manager%20in%20his%2040s%2C%20clean%20white%20background%2C%20business%20suit%2C%20friendly%20expression%2C%20high%20quality%20portrait%20photography%2C%20studio%20lighting&width=80&height=80&seq=t5&orientation=squarish",
    rating: 5,
    text: "전국 50개 매장에 동시에 공지 문자를 보내야 할 때 정말 유용해요. 대량 발송도 끊김 없이 빠르게 처리되고, 발송 결과도 바로 확인할 수 있어서 좋습니다.",
    tag: "대량 발송",
  },
  {
    name: "한소희",
    role: "스타트업 창업자",
    company: "에듀테크 플랫폼 CEO",
    avatar: "https://readdy.ai/api/search-image?query=professional%20korean%20female%20startup%20founder%20in%20her%20late%2020s%2C%20clean%20white%20background%2C%20modern%20casual%20attire%2C%20bright%20smile%2C%20high%20quality%20portrait%20photography%2C%20natural%20studio%20lighting&width=80&height=80&seq=t6&orientation=squarish",
    rating: 5,
    text: "처음엔 가격이 저렴해서 반신반의했는데, 발송 성공률이 정말 99.9%에 가깝더라고요. 고객 지원도 빠르고 친절해서 계속 쓰게 됩니다.",
    tag: "발송 안정성",
  },
];

function StarRating({ count }: { count: number }) {
  return (
    <div className="flex items-center gap-0.5">
      {Array.from({ length: count }).map((_, i) => (
        <div key={i} className="w-4 h-4 flex items-center justify-center">
          <i className="ri-star-fill text-yellow-400 text-sm"></i>
        </div>
      ))}
    </div>
  );
}

export default function TestimonialsSection() {
  const [activeIndex, setActiveIndex] = useState(0);
  const [isAnimating, setIsAnimating] = useState(false);
  const intervalRef = useRef<ReturnType<typeof setInterval> | null>(null);

  const goTo = (index: number) => {
    if (isAnimating) return;
    setIsAnimating(true);
    setActiveIndex(index);
    setTimeout(() => setIsAnimating(false), 400);
  };

  const next = () => goTo((activeIndex + 1) % testimonials.length);
  const prev = () => goTo((activeIndex - 1 + testimonials.length) % testimonials.length);

  useEffect(() => {
    intervalRef.current = setInterval(() => {
      setActiveIndex((prev) => (prev + 1) % testimonials.length);
    }, 4500);
    return () => {
      if (intervalRef.current) clearInterval(intervalRef.current);
    };
  }, []);

  const resetInterval = () => {
    if (intervalRef.current) clearInterval(intervalRef.current);
    intervalRef.current = setInterval(() => {
      setActiveIndex((prev) => (prev + 1) % testimonials.length);
    }, 4500);
  };

  const handleNav = (fn: () => void) => {
    fn();
    resetInterval();
  };

  // Show 3 cards at a time on desktop
  const visibleIndices = [
    activeIndex % testimonials.length,
    (activeIndex + 1) % testimonials.length,
    (activeIndex + 2) % testimonials.length,
  ];

  return (
    <section id="testimonials" className="bg-[#0c0c1e] py-24 px-6 relative overflow-hidden">
      {/* Decorative lines */}
      <div className="absolute top-0 left-0 w-full h-px bg-gradient-to-r from-transparent via-violet-500/30 to-transparent" />
      <div className="absolute bottom-0 left-0 w-full h-px bg-gradient-to-r from-transparent via-pink-500/20 to-transparent" />
      <div className="absolute top-1/2 left-1/2 -translate-x-1/2 -translate-y-1/2 w-[700px] h-[300px] bg-violet-900/10 rounded-full blur-3xl pointer-events-none" />

      <div className="max-w-6xl mx-auto relative z-10">
        {/* Header */}
        <div className="text-center mb-14">
          <span className="text-violet-400 text-xs font-semibold tracking-widest uppercase mb-3 block">
            TESTIMONIALS
          </span>
          <h2 className="text-4xl md:text-5xl font-bold text-white mb-4">
            고객들의{" "}
            <span className="bg-gradient-to-r from-violet-400 to-pink-400 bg-clip-text text-transparent">
              생생한 후기
            </span>
          </h2>
          <p className="text-gray-400 text-base">
            다양한 업종의 고객들이 Signal SMS와 함께 성장하고 있습니다.
          </p>
        </div>

        {/* Cards - desktop: 3 visible, mobile: 1 */}
        <div className="hidden md:grid grid-cols-3 gap-6 mb-10">
          {visibleIndices.map((idx, pos) => {
            const t = testimonials[idx];
            return (
              <div
                key={`${idx}-${pos}`}
                className={`bg-white/[0.04] border rounded-2xl p-7 flex flex-col gap-5 transition-all duration-400 ${
                  pos === 1
                    ? "border-violet-500/40 bg-gradient-to-b from-violet-900/20 to-pink-900/10 scale-[1.02]"
                    : "border-white/[0.08] hover:border-white/20"
                }`}
                style={{ opacity: isAnimating ? 0.7 : 1, transition: "opacity 0.4s, transform 0.4s" }}
              >
                {/* Quote icon */}
                <div className="w-8 h-8 flex items-center justify-center">
                  <i className="ri-double-quotes-l text-violet-400/60 text-2xl"></i>
                </div>

                {/* Review text */}
                <p className="text-gray-300 text-sm leading-relaxed flex-1">"{t.text}"</p>

                {/* Tag */}
                <span className="inline-flex items-center gap-1.5 bg-violet-500/15 border border-violet-500/25 text-violet-300 text-xs px-3 py-1 rounded-full w-fit">
                  <i className="ri-price-tag-3-line text-xs"></i>
                  {t.tag}
                </span>

                {/* Author */}
                <div className="flex items-center gap-3 pt-2 border-t border-white/[0.06]">
                  <img
                    src={t.avatar}
                    alt={t.name}
                    className="w-10 h-10 rounded-full object-cover object-top shrink-0"
                  />
                  <div className="flex-1 min-w-0">
                    <div className="text-white font-semibold text-sm">{t.name}</div>
                    <div className="text-gray-500 text-xs truncate">{t.company}</div>
                  </div>
                  <StarRating count={t.rating} />
                </div>
              </div>
            );
          })}
        </div>

        {/* Mobile: single card */}
        <div className="md:hidden mb-10">
          <div
            className="bg-white/[0.04] border border-violet-500/30 rounded-2xl p-7 flex flex-col gap-5"
            style={{ opacity: isAnimating ? 0.6 : 1, transition: "opacity 0.4s" }}
          >
            <div className="w-8 h-8 flex items-center justify-center">
              <i className="ri-double-quotes-l text-violet-400/60 text-2xl"></i>
            </div>
            <p className="text-gray-300 text-sm leading-relaxed">"{testimonials[activeIndex].text}"</p>
            <span className="inline-flex items-center gap-1.5 bg-violet-500/15 border border-violet-500/25 text-violet-300 text-xs px-3 py-1 rounded-full w-fit">
              <i className="ri-price-tag-3-line text-xs"></i>
              {testimonials[activeIndex].tag}
            </span>
            <div className="flex items-center gap-3 pt-2 border-t border-white/[0.06]">
              <img
                src={testimonials[activeIndex].avatar}
                alt={testimonials[activeIndex].name}
                className="w-10 h-10 rounded-full object-cover object-top shrink-0"
              />
              <div className="flex-1 min-w-0">
                <div className="text-white font-semibold text-sm">{testimonials[activeIndex].name}</div>
                <div className="text-gray-500 text-xs truncate">{testimonials[activeIndex].company}</div>
              </div>
              <StarRating count={testimonials[activeIndex].rating} />
            </div>
          </div>
        </div>

        {/* Navigation */}
        <div className="flex items-center justify-center gap-6">
          <button
            onClick={() => handleNav(prev)}
            className="w-10 h-10 flex items-center justify-center rounded-full border border-white/15 hover:border-violet-500/50 hover:bg-violet-500/10 text-gray-400 hover:text-white transition-all cursor-pointer"
          >
            <i className="ri-arrow-left-s-line text-lg"></i>
          </button>

          {/* Dots */}
          <div className="flex items-center gap-2">
            {testimonials.map((_, i) => (
              <button
                key={i}
                onClick={() => { goTo(i); resetInterval(); }}
                className={`transition-all duration-300 rounded-full cursor-pointer ${
                  i === activeIndex
                    ? "w-6 h-2 bg-gradient-to-r from-violet-500 to-pink-500"
                    : "w-2 h-2 bg-white/20 hover:bg-white/40"
                }`}
              />
            ))}
          </div>

          <button
            onClick={() => handleNav(next)}
            className="w-10 h-10 flex items-center justify-center rounded-full border border-white/15 hover:border-violet-500/50 hover:bg-violet-500/10 text-gray-400 hover:text-white transition-all cursor-pointer"
          >
            <i className="ri-arrow-right-s-line text-lg"></i>
          </button>
        </div>

        {/* Trust badges */}
        <div className="mt-14 flex flex-wrap items-center justify-center gap-8">
          {[
            { icon: "ri-award-line", text: "2024 우수 서비스 선정" },
            { icon: "ri-verified-badge-line", text: "정보통신부 인증" },
            { icon: "ri-secure-payment-line", text: "안전한 결제 보장" },
            { icon: "ri-customer-service-2-line", text: "24시간 고객 지원" },
          ].map((badge) => (
            <div key={badge.text} className="flex items-center gap-2 text-gray-500 text-sm">
              <div className="w-5 h-5 flex items-center justify-center">
                <i className={`${badge.icon} text-violet-400/70`}></i>
              </div>
              <span>{badge.text}</span>
            </div>
          ))}
        </div>
      </div>
    </section>
  );
}